<template>
  <div class="edit-work-set-group">
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomInput
          label="Название группы работ"
          placeholder="Введите название"
          type="text"
          :value="formData.work_set_check_group_name || ''"
          @change_input="(value) => (formData.work_set_check_group_name = value)"
        />
      </div>
      <div class="form__item">
        <CustomCheckbox
          label="АСР"
          :value="formData.is_asr"
          @change="(value) => (formData.is_asr = value)"
        />
      </div>
      <CustomModalFooter :btn-loading="loading" submit-btn-text="Сохранить" />
    </q-form>
  </div>
</template>

<script setup>
import { ref, reactive, watch } from 'vue'
import CustomInput from '@/components/form/CustomInput'
import CustomCheckbox from '@/components/form/CustomCheckbox'
import CustomModalFooter from '@/components/modal/modals/modal-footer'
import { useCustomSnackbar } from '@/_helpers/hooks/useCustomSnackbar'
import { addGroupConstructive, getGroupConstructive } from '@/views/PackageEntry/services'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  closeModal: {
    type: Function,
    default: () => {}
  }
})

const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar()
const loading = ref(false)

const formData = reactive({
  work_set_check_group_id: null,
  work_set_check_group_name: '',
  is_asr: false
})

function parseIsAsr(value) {
  if (value === true || value === 1 || value === '1') return true
  if (value === 'true') return true
  return false
}

watch(
  () => props.data?.group,
  async (group) => {
    if (!group?.group_id) return
    formData.work_set_check_group_id = group.group_id
    loading.value = true
    const data = await getGroupConstructive(group.group_id)
    loading.value = false
    if (data && typeof data === 'object') {
      formData.work_set_check_group_name = data.work_set_check_group_name ?? ''
      formData.is_asr = parseIsAsr(data.is_asr)
    } else {
      formData.work_set_check_group_name = group.group_name || ''
      formData.is_asr = parseIsAsr(group.is_asr)
    }
  },
  { immediate: true, deep: true }
)

async function onSubmit() {
  if (formData.work_set_check_group_id == null) {
    showErrorSnackbar('Не указана группа')
    return
  }
  loading.value = true
  const res = await addGroupConstructive({
    work_set_check_group_id: formData.work_set_check_group_id,
    work_set_check_group_name: formData.work_set_check_group_name || null,
    is_asr: formData.is_asr
  })
  loading.value = false
  if (!res) {
    showErrorSnackbar('Ошибка сохранения')
    return
  }
  showSucceedSnackbar('Группа работ сохранена')
  props.data?.onSuccess?.()
  props.closeModal()
}
</script>

<style scoped lang="scss">
.edit-work-set-group {
  min-width: 320px;
}
.form__item {
  margin-bottom: 16px;
}
</style>
